export default "__VITE_ASSET__95ff6bdb__"